import { IProductData, ISpuData, useAccessoriesData } from '@/components/accessories/with';
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import SupportContactUs from '@/componentsH5/SupportCommon/SupportContactUs';
import SupportRightContent from '@/componentsH5/SupportCommon/SupportRightContent';
import { useGlobal } from '@/utils/useGlobal';
import { Collapse, Popover, Select } from 'antd';
import { useMemo, useState } from 'react';
import css from './accessories.module.scss';
const { Panel } = Collapse;
const { Option } = Select;

export default function AccessoriesH5({ lang, categoryList }: { lang: any; categoryList: IProductData[] }) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    const [selectOpen, setSelectOpen] = useState(false);

    const { AccessoriesData, AccessoriesHandle } = useAccessoriesData(categoryList);
    const { tabList, productData, productContent, active, visible, currentSpu } = AccessoriesData;
    const { setVisible, handleChoose, handleSearch, handleChangeTab } = AccessoriesHandle;

    const PopoverHTML = useMemo(() => {
        return (
            <div className="content">
                <div className="cover" style={{ display: visible ? 'block' : 'none' }}></div>
                <div
                    className="closeBtnBox"
                    onClick={() => {
                        document.querySelector('.pagelayoutWapper')?.classList.remove('overflow-hidden');
                        setVisible(false);
                    }}
                >
                    <div className="closeBtn">
                        <Image src="/icons/mobileH5/close_black_h5.svg" layout="fill" className="fullImgs" alt={t('accessories.close_btn')} />
                    </div>
                </div>
                <div className="categoryProduct">
                    <ul className="productList">
                        <Collapse
                            expandIconPosition={'right'}
                            accordion
                            ghost
                            defaultActiveKey={[0]}
                            expandIcon={({ isActive }) => (
                                <div className="minusPlusIconBox">
                                    <Image
                                        src={isActive ? '/icons/mobileH5/minus_black_h5.svg' : '/icons/mobileH5/plus_black_h5.svg'}
                                        layout="fill"
                                        className="fullImgs"
                                        alt={isActive ? t('accessories.minus') : t('accessories.plus')}
                                    />
                                </div>
                            )}
                        >
                            {productData.map((item: IProductData, index: number) => {
                                return (
                                    <Panel key={index} header={item.name}>
                                        {item.children.map((childItem: ISpuData, childIndex: number) => (
                                            <div
                                                key={childIndex}
                                                className={`productListBox list
                                        ${currentSpu?.spuId === childItem.spuId ? 'activeProduct' : ''}`}
                                                onClick={() => handleChoose(childItem)}
                                            >
                                                {childItem.name}
                                            </div>
                                        ))}
                                    </Panel>
                                );
                            })}
                        </Collapse>
                    </ul>
                </div>
                <div className="btnBox">
                    <div className="okBtn" onClick={handleSearch}>
                        {lang.site_product_accessories_ok}
                    </div>
                </div>
            </div>
        );
    }, [productData, currentSpu, visible]);

    const proListHTML = useMemo(() => {
        if (productContent && productContent.length > 0) {
            return <SupportRightContent content={productContent} />;
        }
        return (
            <div className="noData">
                <div className="nodataText">{t('accessory.nodata')}</div>
                <div className="noDataImg">
                    <Image src="/img/nodata_h5.png" layout="fill" className="fullImgs" />
                </div>
            </div>
        );
    }, [productContent]);

    return (
        <>
            <div className={`${css.accessoriesH5} container`}>
                <h1 className="accessoriesH5-title">{lang.site_product_accessories}</h1>
                <div className="accessoriesH5-accessories-box">
                    <div className="content">
                        <div className={`left ${selectOpen ? 'selectOpen' : ''}`}>
                            <Select
                                value={active}
                                suffixIcon={
                                    <div className="iconBox">
                                        {/* 下面这行不注释掉，页面异常 */}
                                        <EFArrowDown />
                                    </div>
                                }
                                onChange={handleChangeTab}
                                onDropdownVisibleChange={(val) => setSelectOpen(val)}
                            >
                                {tabList.map((accessory: any, index: number) => (
                                    <Option value={accessory.key} key={index}>
                                        {accessory.text}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="right">
                            <Popover
                                overlayClassName="dropDownMenuH5"
                                content={PopoverHTML}
                                trigger="click"
                                placement="bottomRight"
                                visible={visible}
                                onVisibleChange={(val) => {
                                    document.querySelector('.pagelayoutWapper')?.classList.add('overflow-hidden');
                                    setVisible(val);
                                }}
                            >
                                <a className="ant-dropdown-link" aria-label={lang.site_product_accessories_browse} onClick={(e) => e.preventDefault()}>
                                    {lang.site_product_accessories_browse}
                                    <span className={visible ? 'imgs imgIcon' : 'imgIcon'}>
                                        {/* 下面这行不注释掉，页面异常 */}
                                        {/* <EFArrowDown /> */}
                                    </span>
                                </a>
                            </Popover>
                        </div>
                    </div>
                    <div className="proList">{proListHTML}</div>
                </div>
                <SupportContactUs isShow={true} nodata={!productContent?.length} />
            </div>
        </>
    );
}
